import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Load the necessary plugins
dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'timezone',
})
export class TimezonePipe implements PipeTransform {
  time_zone = localStorage.getItem('time_zone');

  transform(value: any, format: string): any {
    // Convert Unix timestamp to Day.js object and apply timezone
    const dateValue = dayjs.unix(value).tz(this.time_zone).format(format);

    return dateValue;
  }
}
